import React from "react";
import Box from "@mui/material/Box";
import { useLocation, useSearchParams } from "react-router-dom";
import PlayBackground from "../components/PlayBackground";
import { WordWheelAppearanceProvider, useWordWheelAppearance } from "../context/WordWheelAppearanceContext";
import { isTabletLandscapeView, resolveWordWheelView } from "../lib/viewMode";
import { DAILY_PATH, DAILY_PLAY_PATH, PLAY_PATH, SETTINGS_PATH } from "../routes";
import { wwHomeColorsLight } from "../lib/theme";

function WordWheelLayoutInner({ children }) {
    const pathname = useLocation().pathname;
    const [searchParams] = useSearchParams();
    const view = resolveWordWheelView(searchParams.get("view"));
    const tabletLandscape = isTabletLandscapeView(view);
    const isPlay = pathname === PLAY_PATH || pathname === DAILY_PLAY_PATH;
    const isSettings = pathname === SETTINGS_PATH;
    const isDailyHub = pathname === DAILY_PATH;
    const usePlayChrome = isPlay || isSettings;
    const {
        playColors,
        playTheme,
        playBackground,
        homeColors,
        isRandomScene,
        sceneBackground,
    } = useWordWheelAppearance();

    const palette = usePlayChrome ? playColors : (homeColors || wwHomeColorsLight);
    const shellBackground = usePlayChrome
        ? (isRandomScene ? "#0f172a" : playBackground)
        : (isRandomScene ? "#0f172a" : (homeColors?.background || wwHomeColorsLight.background));

    const showSceneBg = isRandomScene && (usePlayChrome || isDailyHub || !usePlayChrome);
    const bgKey = sceneBackground?.id || "deep_sea";

    return (
        <Box
            sx={{
                position: "relative",
                minHeight: "100dvh",
                height: "100dvh",
                background: shellBackground,
                color: palette.text,
                maxWidth: tabletLandscape ? "100%" : 480,
                width: "100%",
                mx: "auto",
                px: tabletLandscape ? { xs: 2, md: 3 } : 2,
                pb: "max(12px, env(safe-area-inset-bottom, 0px))",
                pt: tabletLandscape
                    ? "calc(24px + env(safe-area-inset-top, 0px))"
                    : "calc(40px + env(safe-area-inset-top, 0px))",
                display: "flex",
                flexDirection: "column",
                overflow: isPlay ? "hidden" : "auto",
                boxSizing: "border-box",
                transition: "background 0.35s ease, color 0.35s ease",
            }}
            data-ww-view={view}
        >
            {usePlayChrome ? (
                <PlayBackground background={bgKey} theme={playTheme} />
            ) : showSceneBg ? (
                <PlayBackground background={bgKey} theme="random" />
            ) : null}
            <Box
                sx={{
                    position: "relative",
                    zIndex: 1,
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    minHeight: 0,
                }}
            >
                {children}
            </Box>
        </Box>
    );
}

export default function WordWheelLayout({ children }) {
    return (
        <WordWheelAppearanceProvider>
            <WordWheelLayoutInner>{children}</WordWheelLayoutInner>
        </WordWheelAppearanceProvider>
    );
}
